<template>
  <Toast />
  <nav aria-label="breadcrumb">
    <ul class="list-none p-0 m-0 flex align-items-center font-medium">
      <li>
        <span class="text-500 no-underline line-height-3 cursor-pointer">
          INVENTARIO / KARDEX
        </span>
      </li>
      <li class="px-2" aria-hidden="true">
        <i class="pi pi-angle-right text-500 line-height-3"></i>
      </li>
      <li>
        <span class="text-900 line-height-3 font-semibold"
          >Kardex de Productos</span
        >
      </li>
    </ul>
  </nav>

  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div class="page-header">
      <h1 class="page-title">
        <i class="pi pi-database mr-2"></i>
        KARDEX GENERAL DE PRODUCTOS
      </h1>
      <span class="page-subtitle">
        Seguimiento completo de movimientos de inventario
      </span>
    </div>
    <div class="filter-card">
      <div class="filter-header">
        <i class="pi pi-filter mr-2"></i>
        <span>Filtros de Búsqueda</span>
      </div>
      <div class="p-fluid formgrid grid filter-body">
        <div class="field col-12 md:col-4">
          <i class="pi pi-building mr-2"></i>
          <span class="titulo">SUCURSAL: </span>
          <Dropdown
            v-model="sucursalSelected"
            :options="sucursales"
            optionLabel="nombre"
            optionValue="id"
          />
        </div>
        <div class="field col-12 md:col-2">
          <i class="pi pi-tag mr-2"></i>
          <span class="titulo">C&Oacute;DIGO: </span>
          <InputText
            v-model="codigo_producto"
            placeholder="Código de producto"
            class="text-right"
            @keyup.enter="BuscarFiltro"
          />
        </div>
        <div class="field col-12 md:col-3">
          <i class="pi pi-calendar mr-2"></i>
          <span class="titulo">FECHA INICIO: </span>
          <InputText
            v-model="fecha_inicio"
            type="date"
            dateFormat="dd/mm/yy"
            placeholder="Fecha de inicio"
            class="text-right"
          />
        </div>
        <div class="field col-12 md:col-3">
          <i class="pi pi-calendar mr-2"></i>
          <span class="titulo">FECHA FIN: </span>
          <InputText
            v-model="fecha_fin"
            type="date"
            dateFormat="dd/mm/yy"
            placeholder="Fecha de fin"
            class="text-right"
          />
        </div>
        <div class="field col-12 md:col-9">
          <i class="pi pi-search mr-2"></i>
          <span class="titulo"
            >BUSCAR PRODUCTO POR NOMBRE | DESCRIPCI&Oacute;N | TALLA |
            COLOR</span
          >
          <AutoComplete
            :dropdown="true"
            field="descripcion"
            v-model="productoSelected"
            :suggestions="productosListadoFiltrado"
            @complete="buscarProducto($event)"
            placeholder="Escriba nombre del producto"
            @item-select="BuscarFiltro($event)"
          >
            <template #item="slotProps">
              <div>
                {{ slotProps.item.descripcion
                }}<span v-if="slotProps.item.stock[0]?.talla" class="ml-2"
                  ><strong style="font-size: 0.9rem; color: gray"
                    >Talla:
                  </strong>
                  <span
                    style="
                      background-color: black;
                      color: #f0f0f0;
                      padding: 2px;
                      border-radius: 5px;
                    "
                    >{{ slotProps.item.stock[0]?.talla ?? "" }}
                  </span>
                </span>
                <span v-if="slotProps.item.stock[0]?.color"
                  ><strong style="font-size: 0.9rem; color: gray">
                    Color:
                  </strong>
                  <span style="color: black; font-weight: bold"
                    >{{ slotProps.item.stock[0]?.color ?? "" }} ***
                  </span>
                </span>
                <span
                  :class="
                    stockClass(
                      slotProps.item.stock.length > 0
                        ? slotProps.item.stock[0].cantidad
                        : 0
                    )
                  "
                  ><strong>{{
                    slotProps.item.stock.length > 0
                      ? slotProps.item.stock[0].cantidad
                      : 0
                  }}</strong></span
                >
              </div>
            </template>
          </AutoComplete>
        </div>

        <div class="field col-12 md:col-3">
          <i class="pi pi-cog mr-2"></i>
          <span class="titulo"><strong>ACCIONES: </strong></span>
          <Button
            label="APLICAR FILTROS"
            icon="pi pi-search"
            class="p-button-info mr-2"
            :loading="enviando"
            :disabled="enviando"
            @click="BuscarFiltro"
          />
        </div>
      </div>
    </div>
    <div class="mt-2">
      <DataTable
        ref="dtKardex"
        key="id"
        :value="kardexs"
        responsiveLayout="scroll"
        :loading="enviando"
        class="p-datatable-sm"
        :filters="buscar"
        responsive="true"
        stripedRows
        showGridlines
      >
        <template #header>
          <div
            class="flex justify-content-between align-items-center flex-wrap"
          >
            <div class="flex align-items-center flex-wrap">
              <i class="pi pi-table mr-2"></i>
              <span class="text-xl font-semibold mr-3"
                >Resultados del Kardex:</span
              >
              <div
                v-if="sucursalSelected != 0 || productoSelected"
                class="flex align-items-center gap-2 text-sm flex-wrap mt-2 md:mt-0"
              >
                <span v-if="sucursalSelected != 0">
                  <i class="pi pi-building"></i>
                  <strong>Sucursal:</strong>
                  {{
                    sucursales.find(
                      (sucursal) => sucursal.id === sucursalSelected
                    )?.nombre
                  }}
                </span>

                <span v-if="productoSelected">
                  <i class="pi pi-box mr-1"></i>
                  <strong>Producto:</strong>
                  {{ productoSelected.descripcion }}
                  <span v-if="productoSelected.talla">
                    <strong>Talla:</strong> {{ productoSelected.talla }}
                  </span>
                  <span v-if="productoSelected.color" class="ml-2">
                    <strong>Color:</strong> {{ productoSelected.color }}
                  </span>
                </span>
              </div>
            </div>
            <div class="flex align-items-center gap-1 mt-2 md:mt-0">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="buscar['global'].value"
                  placeholder="Buscar..."
                  class="w-10rem"
                />
              </span>
              <Button
                label="PDF"
                icon="pi pi-file-pdf"
                class="p-button-outlined p-button-danger p-button-sm"
                v-tooltip.top="'Exportar PDF'"
                :loading="generando_pdf"
                :disabled="generando_pdf || kardexs.length === 0"
                @click="generarPDF()"
              />
              <Button
                label="Excel"
                icon="pi pi-file-excel"
                class="p-button-outlined p-button-success p-button-sm"
                v-tooltip.top="'Exportar Excel'"
                :loading="exportando"
                :disabled="exportando || kardexs.length === 0"
                @click="exportKardexs()"
              />
            </div>
          </div>
        </template>
        <template #loading
          ><div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
          ></template
        >
        <template #empty>
          <span class="p-invalid">
            Debe aplicar filtros para ver resultados en la tabla!</span
          >
        </template>
        <Column
          field="nombre_sucursal"
          header="SUCURSAL"
          v-if="sucursalSelected == 0"
        ></Column>
        <Column field="fecha" header="FECHA" :sortable="true"></Column>
        <Column field="detalle" header="DETALLE" class="detalle-columna">
        </Column>
        <Column :class="'text-right'" field="ent_cantidad" header="E_CANT.">
          <template #body="data">
            <span style="font-weight: bold">
              {{ sinDecimal(data.data.ent_cantidad) }}
            </span>
          </template>
        </Column>
        <Column :class="'text-right'" field="ent_costo" header="E_COSTO">
          <template #body="data">
            <span
              :style="
                data.data.ent_costo > 0
                  ? 'color: green; font-weight: bold'
                  : 'font-weight: bold'
              "
            >
              {{ convertirNumeroGermanicFormat(data.data.ent_costo) }}
            </span>
          </template>
        </Column>
        <Column :class="'text-right'" field="ent_total" header="E_TOTAL">
          <template #body="data">
            <span style="font-weight: bold">
              {{ convertirNumeroGermanicFormat(data.data.ent_total) }}
            </span>
          </template>
        </Column>
        <Column :class="'text-right'" field="sal_cantidad" header="S_CANT">
          <template #body="data">
            <span
              :style="
                data.data.sal_cantidad > 0
                  ? 'color: red; font-weight: bold'
                  : 'font-weight: bold'
              "
            >
              {{ sinDecimal(data.data.sal_cantidad) }}
            </span>
          </template>
        </Column>
        <Column :class="'text-right'" field="sal_costo" header="S_COSTO">
          <template #body="data">
            <span style="font-weight: bold">
              {{ convertirNumeroGermanicFormat(data.data.sal_costo) }}
            </span>
          </template>
        </Column>
        <Column :class="'text-right'" field="sal_total" header="S_TOTAL">
          <template #body="data">
            <span style="font-weight: bold">
              {{ convertirNumeroGermanicFormat(data.data.sal_total) }}
            </span>
          </template>
        </Column>
        <Column
          :class="'text-right'"
          field="saldo_cantidad"
          header="EXISTENCIA"
        >
          <template #body="data">
            <div
              :class="stockClass(data.data.saldo_cantidad)"
              style="text-align: center"
            >
              {{ sinDecimal(data.data.saldo_cantidad) }}
            </div>
          </template>
        </Column>
        <Column :class="'text-right'" field="saldo_total" header="SALDO_TOTAL">
          <template #body="data">
            <span style="font-weight: bold">
              {{ convertirNumeroGermanicFormat(data.data.saldo_total) }}
            </span>
          </template>
        </Column>
        <Column :class="'text-right'" field="cpp" header="CPP">
          <template #body="data">
            <span style="font-weight: bold">
              {{ convertirNumeroGermanicFormat(data.data.cpp) }}
            </span>
          </template>
        </Column>
        <Column field="usuario" header="USUARIO"></Column>
      </DataTable>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "@/service/ProductService";
import KardexService from "@/service/KardexService";
import SucursalService from "@/service/SucursalService";

export default {
  data() {
    return {
      kardexs: [],
      productoSelected: null,
      productosListadoFiltrado: [],
      enviando: false,
      generando_pdf: false,
      exportando: false,
      fecha_inicio: null,
      fecha_fin: null,
      buscar: {
        global: { matchMode: FilterMatchMode.CONTAINS, value: null },
      },
      sucursales: [{ id: 0, nombre: "TODAS" }],
      sucursalSelected: 0,
      codigo_producto: null,
      stockClass: (data) => {
        if (data <= 0) {
          return "outofstock";
        } else if (data <= 10) {
          return "lowstock";
        } else {
          return "instock";
        }
      },
    };
  },
  productService: null,
  kardexService: null,
  sucursalService: null,
  created() {
    this.productService = new ProductService();
    this.kardexService = new KardexService();
    this.sucursalService = new SucursalService();
  },
  mounted() {
    this.cargarSucursales();
  },
  methods: {
    sinDecimal(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 0,
      }).format(numero);
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: 2,
      }).format(numero);
    },
    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((response) => {
          response.forEach((sucursal) => {
            this.sucursales.push(sucursal);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportKardexs() {
      if (this.kardexs.length > 0) {
        this.exportando = true;
        let datos = {
          producto_id: this.productoSelected ? this.productoSelected.id : null,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          sucursal_id:
            this.sucursalSelected == 0 ? null : this.sucursalSelected,
          codigo_producto: this.codigo_producto ? this.codigo_producto : null,
        };
        this.kardexService.exportKardexs(datos).then(() => {
          this.exportando = false;
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: "Se exportó correctamente",
            life: 3000,
          });
        });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "No hay datos para exportar",
          life: 3000,
        });
      }
    },
    generarPDF() {
      if (this.kardexs.length > 0) {
        this.generando_pdf = true;
        let datos = {
          producto_id: this.productoSelected ? this.productoSelected.id : null,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          sucursal_id:
            this.sucursalSelected == 0 ? null : this.sucursalSelected,
          codigo_producto: this.codigo_producto ? this.codigo_producto : null,
        };
        this.kardexService.generarPDF(datos).then(() => {
          this.generando_pdf = false;

          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: "Se generó el PDF correctamente",
            life: 3000,
          });
        });
      } else {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "No hay datos para generar el PDF",
          life: 3000,
        });
      }
    },
    buscarProducto(event) {
      setTimeout(() => {
        this.productService
          .buscarXNombre({
            texto: event.query,
            sucursal_id: this.sucursalSelected,
          })
          .then((response) => {
            this.productosListadoFiltrado = [...response.productos];
          })
          .catch((error) => console.log(error));
      }, 250);
    },
    BuscarFiltro() {
      // Validar que se haya seleccionado un producto
      if (!this.productoSelected && !this.codigo_producto) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: "Debe seleccionar un producto o ingresar un código",
          life: 3000,
        });
        return;
      }
      this.kardexs = [];
      this.enviando = true;
      this.cargarProductosFiltros();
    },
    cargarProductosFiltros() {
      let datos = {
        producto_id: this.productoSelected ? this.productoSelected.id : null,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        sucursal_id: this.sucursalSelected,
        codigo_producto: this.codigo_producto ? this.codigo_producto : null,
      };
      this.kardexService
        .filtrarKardexs(datos)
        .then((response) => {
          this.kardexs = response.kardexs;
          this.enviando = false;
        })
        .catch(() => {
          this.enviando = false;
        });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-fondo {
  background-color: #7bffae;
  border-radius: 5px;
  border: 1px solid #002236;
  padding: 5px;
}
.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #ff5252;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}
.page-header {
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

.page-title {
  color: #2c3e50;
  font-size: 1.75rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  display: flex;
  align-items: center;
}
.page-subtitle {
  color: #6c757d;
  margin: 0;
  font-size: 1rem;
}
.filter-card {
  background: #fff;
  border-radius: 10px;
  border-bottom: 2px solid #2c3e50;
  margin-bottom: 1rem;
  overflow: hidden;
}

.filter-header {
  background: linear-gradient(90deg, #2b7fb8, #2c3e50);
  color: white;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.filter-body {
  padding: 1rem;
  background-color: #ffffff;
}

.titulo {
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #2c3e50;
  font-size: 0.9rem;
}
/* Estilo para la columna de DETALLE */
.detalle-columna {
  // Sobreescribe el white-space-nowrap de la tabla
  white-space: normal !important; 
  // Usa el espacio disponible
  width: auto !important; 
  // Limita el ancho máximo para que no se expanda demasiado
  max-width: 400px; /* Puedes ajustar este valor si es necesario */ 
}

/* Opcional: Para evitar que el texto se salga si no puede ajustarse */
.detalle-columna .p-column-title,
.detalle-columna .p-column-header,
.detalle-columna .p-datatable-tbody > tr > td {
    overflow-wrap: break-word; // Asegura que las palabras largas se corten
    word-wrap: break-word;
}
</style>
